<template>
  <div class="app-body" ref="body">
    <app-header is-left @click-left="goBack">
      <div slot="title">提交订单</div>
    </app-header>
    <van-cell-group title="订单详情">
      <van-cell title="名称">
        {{ order.name }}
      </van-cell>
      <van-cell title="单价/数量">
        <div class="detail-price1">
          <div class="price"><small>¥</small><span class="font-bold">{{ order.price }}</span></div>
          <div class="count">&nbsp;× {{ order.count }}</div>
        </div>
      </van-cell>
      <van-cell title="总价">
        <div class="detail-price2">
          <div class="price2"><small>¥</small><span class="font-bold">{{ formatPrice(order.amount) }}</span></div>
        </div>
      </van-cell>
    </van-cell-group>
    <!-- <van-cell-group title="收件地址">
      <van-cell title="" :to="{name:'user-address', params:{back:'/order-s/'+ id}}" is-link>
        <div slot="label">{{ memberaddress }} </div>
      </van-cell>
    </van-cell-group> -->
    <div class="detail-bottom">
      <van-button type="danger" block @click="doPay">{{ order.price ? '微信支付' : '立即报名' }}</van-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import tools from '@/utils/tools';
import AppHeader from '../app-header.vue';
import AppFooter from '../app-footer.vue';
export default {
  components: {
    AppHeader, AppFooter
  },
  mixins: [tools],
  props: ['id', 'back'],
  data() {
    return {
      isLoading: false,
      order: {}
    }
  },
  computed: {
    memberaddress() {
      let _address = '~还没有地址，点击添加收件地址';
      let address = this.member.address;
      if (address && address.address) {
        _address = '';
        if (address.name || address.tel) {
          _address += '【'+ (address.name || '') +' / '+ (address.tel || '') +'】'
        }
        _address += (address.province || '') + (address.city || '') + (address.county || '') + (address.address || '');
      }
      return _address;
    }
  },
  watch: {
    id() {
      this.getData();
    }
  },
  created () {
  },
  mounted () {
  },
  activated() {
    if (!this.order.id) {
      this.getData();
    }
  },
  methods: {
    getData() {
      if (this.isLoading || !this.id) {
        return;
      }
      this.isLoading = true;
      this.Toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      this.doGet({
        url: 'vue/home/order/'+ this.id,
        okcb: (json) => {
          this.order = json || {};
        },
        cb: () => {
          this.$nextTick(() => this.isLoading = false);
          this.Toast.clear();
        }
      });
    },
    goBack() {
      this.$router.push(this.back || '/detail-s/'+ this.order.activityid);
    },
    formatPrice(price) {
      return '' + (price);
    },
    doPay() {
      let item = this.order;
      if (!item.id) {
        return;
      }
      // if (!this.member.address && !this.member.address.id) {
      //   this.Dialog.alert({
      //     message: '请选择收件地址！'
      //   }).then(() => {
      //     // on close
      //   });
      //   return;
      // }
      this.doPost({
        url: 'vue/pay/wxpay2/'+ item.id,
        data: {openid: this.member.openid, addressid: this.member.address.id},
        okcb: (json) => {
          // 如果需要登录获取openid
          if (json.needopenid) {
            this.login();
            return;
          }
          if (json.ok) {
            this.Toast('已完成支付！');
            item.status = json.status;
            return;
          }
          let params = {goods: {name: item.name, amount: item.amount, price: item.price, count: item.count}, orderid: json.orderid };
          if (json.code_url) {
            params.codeUrl = json.code_url;
          } else {
            params.wxpayparams = JSON.parse(json.payparams);
          }
          // 支付界面
          // this.payforward = true;
          this.$router.push({ name:'goods-pay', params: params });
        },
        cb: () => {
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.app-body{margin-top:46px; margin-bottom:50px; background-color:#f5f5f5;}
.detail {
  &-price1 {
    .flex-center-v();
    justify-content:flex-end;
  }
  &-price2 {
    .price2 {
      .fontsize(1.4rem);
      color:@orangecolor;
    }
  }
  &-bottom {
    position:fixed;
    bottom:0;
    left:0;
    z-index:999;
    box-sizing:border-box;
    width:100%;
    padding:5px 16px;
    background-color:#fff;
  }
}
</style>